module.exports = __webpack_public_path__ + "img/Haefele_menu3.26cc3adc.png";